export default "/images/vendor/flag-icon-css/flags/1x1/bw.svg?0acc600b67ac7165e38c1f691d70c839";